export const DEFAULT_TELEGRAM_STATE = {
  botConfigs: [],
  contacts: [],
  messages: [],

  selectedBotConfigId: null,
  selectedChatId: null,
  selectedContact: null,

  loading: false,
  error: null,

  page: 0,
  limit: 30,
  totalCount: 0,
  hasMore: true,

  messageSending: false,
  isUserSelected: false,

  isRecAudioSelect: false,
  agentSearchItem: null,
};
